import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import GroupButton from 'components/button/groupButton';
import { Modal } from 'flowbite-react';
import { messageErrors } from 'utils/utils';

import './removeModal.scss';

function HiOutlineExclamationCircle() {
  return null;
}

type RemoveModalProps = {
  openModal: boolean;
  setOpenModal: Function;
  title: string;
  successDeleteMessage: string;
  mutation: any;
  refetchApi: Function;
  selectItemId: string;
};

const RemoveModal = (props: RemoveModalProps) => {
  const { t } = useTranslation();
  const { openModal = false, setOpenModal, title, mutation, refetchApi, successDeleteMessage, selectItemId } = props;
  const closeModalHandler = () => {
    setOpenModal(!openModal);
  };

  const confirmHandler = () => {
    const successCallback = (message: string) => {
      setOpenModal(!openModal);
      refetchApi();
      toast.success(message);
    };
    mutation.mutate(selectItemId, {
      onSuccess: () => {
        const message: string = t(successDeleteMessage);
        successCallback(message);
      },
      onError: (error: any) => {
        const message: string = messageErrors(error, t);
        toast.error(message);
      },
    });
  };

  useEffect(() => {
    if (openModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [openModal]);

  return (
    <Modal id="remove-modal" dismissible={true} show={openModal} size="md" popup={true} onClose={() => closeModalHandler()}>
      <Modal.Header>{''}</Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle />
          <h3 className="main-text mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"> {t('removeMessageModal', { title })}</h3>
          <GroupButton
            className="w-full gap-2 justify-center pb-2"
            buttons={[
              {
                type: 'button',
                text: t('modal.noCancel'),
                classType: 'white',
                action: () => closeModalHandler(),
              },
              {
                type: 'submit',
                text: t('modal.yesImSure'),
                classType: 'blue',
                action: () => confirmHandler(),
              },
            ]}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RemoveModal;
